import React, { useRef } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useMsal } from "@azure/msal-react";

const AppTopbar = ({ activeUser, tabs, activeIndex, onTabSelect }) => {
	const navigate = useNavigate();
	const menuRef = useRef(null);
	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();

	const menuItems = [
		{ label: 'Logout', icon: 'pi pi-fw pi-sign-out', command: () => handleLogout() }
	];

	const toDashboard = () => {
		navigate('/map');
	};

	const handleLogout = () => {
		const logoutRequest = {
			account: instance.getAccountByHomeId(activeAccount.homeAccountId),
		};
		instance.logoutRedirect(logoutRequest);
	};

	return (
		<div className="topbar clearfix">
			<div className="topbar-left">
				<button type="button" className="p-link" onClick={toDashboard}>
					<img alt="Logo"
						src="assets/layout/images/logo.png"
						className="topbar-logo"
					/>
					<div>GatesNow</div>
				</button>
			</div>

			{tabs?.length ? (
				<nav className="gatesnow-tabs gatesnow-tabs--topbar" aria-label="Gates Now views">
					{tabs.map((tab, index) => (
						<button
							key={tab.path}
							type="button"
							className={classNames('gatesnow-tab', { 'is-active': activeIndex === index })}
							aria-current={activeIndex === index ? 'page' : undefined}
							onClick={() => onTabSelect?.(tab.path)}
						>
							<i className={tab.icon} aria-hidden />
							<span>{tab.label}</span>
						</button>
					))}
				</nav>
			) : null}

			<div className="topbar-right acaa">
				<div className="p-link user-menu">
					<Button onClick={(e) => menuRef.current.toggle(e)}
						className="menu-toggle"
						aria-controls="popup_menu"
						aria-haspopup
					>
						<div>
							<div>
								<div className="name">{activeUser?.userInfo?.personalInfo?.firstName}</div>{" "}
								<div className="name">{activeUser?.userInfo?.personalInfo?.lastName}</div>
							</div>
							<div className="title">{activeUser?.userInfo?.personalInfo?.title}</div>
						</div>
						<img src={activeUser?.userInfo?.photo} alt="User photo" />
					</Button>
					<Menu model={menuItems}
						ref={menuRef}
						id="popup_menu"
						popup
					/>
				</div>
			</div>
		</div>
	);
};

export default AppTopbar;
